import React, { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BasketIcon from '../../icons/BasketIcon';
import AppTagChipArray from './AppTagChipArray';
import AppTagChipArrayTop from './AppTagChipArrayTop';
import SimpleAppTagChipArrayBottom from './SimpleAppTagChipArrayBottom';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../../other/translate.json';
import ArrowSendIcon from '../../icons/ArrowSendIcon';
import Chip from '@material-ui/core/Chip';
import icons_bn from '../../other/icons_bn.json';

let moment = require('moment');

export default function DevDynCard(props) {

	const classes = useStyles();
	let { setAppBasket, readLink, basketChips, type, basket, notDeleteFromBasketArr } = props
	let { bank } = useParams()
	let lang = localStorage.getItem('language') || 'Ru'
	const [height, setHeight] = useState(0)
	const ref = useRef(null)
	let langYE = lang === 'Ru' ? '(тыс.у.е.)' : '(K c.u.)'
	let langYEM = lang === 'Ru' ? '(тыс.у.е.)/мес.' : '(K c.u.)/month'
	let IsRu = lang === 'Ru'
	const stabilyzeChipArr = (arr) => {
		let newArr = [];
		arr.map(el => {
			if (!newArr.includes(el)) {
				newArr.push(el)
			}
		})
		let vers = props.data.Progress.split(' ')[1];
		if (!newArr.includes(vers)) {
			newArr.push(vers)
		}
		newArr = newArr.sort();
		//console.log("stabilyzeChipArr", arr, newArr)
		if (newArr.length === 4 || newArr.length === 5) {
			return newArr.length === 4 ? [newArr[0], newArr[1], newArr[2], 'delimiter', 'delimiter', newArr[3]] : [newArr[0], newArr[1], newArr[2], 'delimiter', newArr[3], newArr[4]]
		} else return newArr

	}
	useEffect(() => {
		setHeight(ref.current.clientHeight)
	}, [bank])

	function PriceCommentELP() {
		return (
			<span>
				{translate.Words[`Price11${lang}`]}
				/
				<br />
				{translate.Words[`Price12${lang}`]}
			</span>
		)
	}

	return (
		<Card className={props.wide === false ? classes.rootNarrow : classes.rootWide} >
			<Grid container style={{ height: 32 }}>
				{
					basket
						?
						<AppTagChipArrayTop
							lang={lang}
							DateEndSaleStock={props.data.DateEndSaleStock}
							DateStartStock={props.data.DateStartStock}
							StockLink={props.data.StockLink}
							dataStartSale={props.data.DateStartSale}
							isStandant={props.data && props.data.IsStandartPackage}
							isResearchMarket={props.data && props.data.IsResearchMarket}
							dataEndSale={props.data && props.data.DateEndSale}
							position='top'
						/>
						:
						<Grid container direction="row" justify={/*Array.isArray(props.data.additional_versions) && props.data.additional_versions.length > 0 ? "space-between" :*/ "flex-end"} alignItems="center" key={`${props.data.key}__topChipData`} className={classes.li}>
							{
								Array.isArray(props.data.additional_versions) && (props.data.Progress.slice(0, 5) === 'Новое' || props.data.Progress.slice(0, 3) === 'New')
									?
									stabilyzeChipArr(props.data.additional_versions).map((elem, i) => {
										return (
											<Chip
												style={{
													backgroundColor: elem === 'delimiter' ? 'transparent' : '#81D39D',
													width: elem === 'delimiter' ? '84px' : undefined,
													marginTop: i === 5 || i === 4 ? 3 : undefined,
													marginRight: i !== 2 && i !== 5 && i !== 4 ? 4 : undefined,
													visibility: elem === 'delimiter' ? 'hidden' : undefined
												}}
												label={`${lang === 'Ru' && elem !== 'delimiter' ? 'Новое' : elem !== 'delimiter' ? 'New' : ''} ${elem === 'delimiter' ? '' : elem}`}
												className={classes.chip}
											/>
										)
									})
									:
									null
							}

							{Array.isArray(props.data.additional_versions) && (props.data.Progress.slice(0, 5) === 'Новое' || props.data.Progress.slice(0, 3) === 'New')

								?
								null
								:
								<Chip
									style={{ backgroundColor: props.data.Progress.slice(0, 8) === 'Развитие' || props.data.Progress.slice(0, 11) === 'Development' ? '#8094FF' : props.data.Progress.slice(0, 5) === 'Новое' || props.data.Progress.slice(0, 3) === 'New' ? '#81D39D' : props.data.Progress.slice(0, 5) === 'Анонс' || props.data.Progress.slice(0, 11) === 'Coming soon' ? '#FE9D67' : '' }}
									label={props.data.Progress}
									className={classes.chip}
								/>
							}

						</Grid>
				}
			</Grid>

			<Grid item style={{ width: '100%' }}>
				<Typography component='span' style={{ fontSize: '14px' }}>{lang === "Ru" ? 'ЦФТ-Банк' : "CFT Bank"}</Typography>
			</Grid>

			<CustomCardHeader className={classes.header}
				avatar={
					<Avatar aria-label="recipe" className={classes.avatar}
						style={{ backgroundColor: props.data.COLOR && props.data.COLOR.length > 5 ? `#${props.data.COLOR}` : '#E45670' }}
						// src={props.data.Icon}
						src={icons_bn[`${props.data["ICON_ID_BN"]}`]}
					/>
				}

				title={
					<Typography style={{ fontSize: '12px', lineHeight: '14px', fontWeight: '500' }}>
						{props.data[`BN_Title`]}
					</Typography>
				}

				subheader={
					<Typography className={classes.subheader} style={{ marginTop: 4 }}>
						{props.data[`SN_Title`]}
					</Typography>
				}
			/>

			<CardContent className={classes.content}>
				<Grid container direction="column" justify="space-between" alignItems="stretch" style={{ height: '100%' }}>
					<Grid container style={{ height: 315, overflow: 'hidden' }}>
						<Grid container direction="column" justify="flex-start" alignItems="flex-start">
							{
								readLink === false
									?
									<a ref={ref} href={`/${type}/card/${props.data.CodeAsvul}`} style={{ textDecoration: 'none', width: '100%' }} rel="noopener noreferrer" target="_blank">
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
											{props.data.Title}
										</Typography>


									</a>
									:
									<Grid item ref={ref}>
										<Typography variant="body2" color="textSecondary" component="p" className={classes.contentBody}>
											{props.data.Title}
										</Typography>
									</Grid>
								/** высота грида ???  */
							}

							{
								readLink === false
									?
									<a href={`/${type}/card/${props.data.CodeAsvul}`} style={{ textDecoration: 'none', marginTop: 8, height: 315 - height, overflow: 'hidden' }} rel="noopener noreferrer" target="_blank">
										<Grid
											container
											direction="row"
											justify="space-between"
											alignItems="flex-start"
										>
											{/* <Grid item style={{ backgroundColor: props.data.bgcolor ? props.data.bgcolor : 'grey', borderRadius: '50%', width: 16 }}>
												<ArrowlinkIcon fill={'#FFFFFF'} />
											</Grid> */}

											<Grid item style={{ width: 'calc(100%)' }}>
												<Typography className={classes.Body2}>{props.data.Progress2}</Typography>

												<Typography variant="body2" color="textSecondary" component="p" style={{ height: 315 - height }} className={classes.contentSubbody}>
													<div dangerouslySetInnerHTML={{ __html: props.data.BriefDescription }}></div>
												</Typography>
											</Grid>
										</Grid>
									</a>
									:
									<Typography variant="body2" color="textSecondary" component="p" style={{ height: 315 - height }} className={classes.contentSubbody}>
										<div dangerouslySetInnerHTML={{ __html: props.data.BriefDescription }}></div>
									</Typography>
							}
						</Grid>
					</Grid>

					<Grid container direction="row" justify="flex-start" alignItems="center" className={classes.container} spacing={3} style={{ marginTop: 19 }}>
						{props.data.IsResearchMarket ? "" : <AppTagChipArray position='middle' key1={props.data.CodeAsvul} key2={props.data.Version} key3={props.data.DateStartSale} />}
					</Grid>

					{props.data.PaymentOne >= 0 ?
						<React.Fragment>
							<Grid container direction="row" justify="flex-start" alignItems="center" className={classes.container} spacing={3} style={{ margin: '20px 0 0 0' }}>
								<Grid item style={{ padding: 0, marginBottom: 3 }}>
									<Typography className={classes.subheader}>
										{translate.Words[`Price${lang}`]}  {props.data.PaymentComment_Ru && props.data.PaymentComment_Ru.length > 0 ? '*' : ''}
									</Typography>
								</Grid>

								<Grid item container direction="row" className={classes.priceContainer} style={{ padding: 0 }}>
									<Grid item container direction="row" style={{ width: 93 }}>
										<CustomTooltip title={PriceCommentELP()}>
											<Typography className={classes.pricePrimary}>{+props.data.PaymentOne === 0 ? translate.Words[`NotCharged${lang}`] : ` ${props.data.PaymentOne} ${langYE}`}{props.data.PaymentCommentOne_Ru && props.data.PaymentCommentOne_Ru.length > 0 ? '*' : ''}{props.data.PaymentComment_Ru && props.data.PaymentComment_Ru.length > 0 ? '*' : ''}</Typography>
										</CustomTooltip>
										{props.data.PaymentOneStock !== undefined && +props.data.PaymentOneStock > 0
											?
											<CustomTooltip title={IsRu ? 'Особые условия лицензирования – см. страницу с описанием Приложения' : "Special license terms – see. Application description page"}>
												<Typography className={classes.priceSecondary}>{props.data.PaymentOneStock} {langYE}</Typography>
											</CustomTooltip>
											:
											''
										}
									</Grid>

									<Grid item container direction="row" xs={6} style={{ marginLeft: 16 }}>
										<CustomTooltip title={IsRu ? 'Ежемесячный лицензионный платеж / Периодическая лицензия' :
											"Monthly license payment / Periodic license"}>
											<Typography className={classes.pricePrimary}>
												{props.data && props.data.PaymentMonthly} {langYEM}
											</Typography>
										</CustomTooltip>
										<Typography className={classes.pricePrimary} style={{ cursor: 'default' }}>*{props.data.PaymentComment_Ru && props.data.PaymentComment_Ru.length > 0 ? '*' : ''} {props.data.PaymentCommentOne_Ru && props.data.PaymentCommentOne_Ru.length > 0 ? '*' : ''}</Typography>
										{props.data && props.data.PaymentMonthlyStock ? <Typography className={classes.priceSecondary}>{props.data.PaymentMonthlyStock} {langYEM}</Typography> : ''}

										{/* {
											props.data.PaymentCommentMonthly_Ru && props.data.PaymentCommentMonthly_Ru.length > 0 ?
												<CustomTooltip title={IsRu ? 'Особые условия лицензирования – см. страницу с описанием Приложения' : "Special license terms – see. Application description page"}>
													<Typography className={classes.pricePrimary} style={{ cursor: 'default' }}>*</Typography>
												</CustomTooltip>
												:
												''
										} */}
									</Grid>
								</Grid>
							</Grid>
							{props.data.Tags && props.data.Tags.length > 0 ?
								<Grid container direction="row" justify="flex-start" alignItems="center" className={classes.container} spacing={3} style={{ marginTop: 10 }}>
									<SimpleAppTagChipArrayBottom position='bottom' icon={false} tags={props.data.Tags} />
								</Grid> : ''}
						</React.Fragment>
						: ''
					}
				</Grid>
			</CardContent>

			{
				props.basket === false
					?
					''
					:


					<CardActions disableSpacing className={classes.actions}
						onClick={() =>
							notDeleteFromBasketArr && notDeleteFromBasketArr.includes(props.data.ID + '')
								? '' :
								setAppBasket(props.data)}
					/* className={clsx({
						[classes.actions]: !props.dynamics,
						[classes.DN]: props.dynamics
					})}*/
					>
						{/* <IconButton aria-label="share" className={classes.icon}>
						<FavoritesIcon fill={'#BCBBD0'} />
					</IconButton> */}
						{props.data && props.data.IsResearchMarket
							?
							// <CardButton
							// 	text={'Повысить приоритет'}
							// 	bgcolor={'#74D972'}
							// 	shadow={'0px 6px 24px rgba(116, 217, 114, 0.4)'}
							// />

							<CustomTooltip title={translate.Words[`Prioritize${lang}`]}>
								<IconButton aria-label="share" className={classes.icon}>
									<ArrowSendIcon fill={'#BCBBD0'} />
								</IconButton>
							</CustomTooltip>
							:

							(props.data.DateEndSale && '1900-01-01T00:00:00.000Z' !== props.data.DateEndSale && moment(props.data.DateEndSale) < new Date()) ? "" :
								notDeleteFromBasketArr && notDeleteFromBasketArr.includes(props.data.ID + '') ?
									<CustomTooltip title={translate.Words[`AppIsPartOfProducts_${lang}`]}>
										<IconButton aria-label="share" className={classes.icon}>
											<BasketIcon fill={'#BCBBD0'} />
										</IconButton>
									</CustomTooltip>
									:
									<CustomTooltip title={basketChips && basketChips.includes(props.data.CodeAsvul) ? translate.Words[`RemoveFromBasket${lang}`] : translate.Words[`AddTobasket${lang}`]}>
										<IconButton aria-label="share" className={classes.icon}>
											<BasketIcon fill={'#BCBBD0'} />
										</IconButton>
									</CustomTooltip>
						}
					</CardActions>
			}

		</Card>
	);
}

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);

const CustomCardHeader = withStyles((theme) => ({
	root: {
		alignItems: 'flex-start'
	},

	avatar: {
		marginRight: 8
	},
}))(CardHeader);



const useStyles = makeStyles((theme) => ({
	rootNarrow: {
		// maxWidth: 345,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		paddingTop: 8,
		paddingBottom: 16,
		padding: theme.spacing(3),
		// minHeight: 480,
		// height: 480,
		// maxHeight: 480,
		minWidth: 312,
		width: 312,
		maxWidth: 312,
		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	rootWide: {
		// maxWidth: 345,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		paddingTop: 10,
		paddingBottom: 16,
		padding: theme.spacing(3),
		minHeight: 246,
		height: 246,
		maxHeight: 246,
		minWidth: 312,
		width: '100%',
		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	avatar: {
		// backgroundColor: props.iconColor,
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#F6F6FB',
		width: 48,
		height: 48,
		'&:hover': {
			backgroundColor: '#F6F6FB',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		height: 370,
		// overflow: 'hidden',
		padding: 0,
		marginTop: 16
	},

	contentBody: {
		fontSize: '14px',
		fontWeight: '500',
		lineHeight: '18px',
		color: '#000'
	},

	contentSubbody: {
		marginTop: 0 /* theme.spacing(1) */,
		fontSize: '13px',
		fontWeight: '400',
		lineHeight: '16px',
		color: '#8987A2'
	},

	header: {
		marginTop: 4,
		padding: 0,

		title: {
			fontSize: 22
		}
	},

	subheader: {
		fontSize: '12px',
		lineHeight: '14px',
		fontWeight: 400,
		color: '#8987A2'
	},

	actions: {
		padding: '0',
		paddingTop: '7',
		// position: 'absolute',
		// bottom: 16,
		// right: 24
	},

	pricePrimary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#000'
	},

	priceSecondary: {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '18px',
		color: '#8987A2'
	},

	DN: {
		display: 'none'
	},

	Body2: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '14px',
		lineHeight: '18px',
		color: '#000000'
	},

	chip: {
		height: 24,
		margin: 0,
		padding: theme.spacing(0, 1),
		backgroundColor: '#BCBBD0',
		fontSize: 13,
		lineHeight: '16px',
		color: '#FFF',
		borderRadius: 39,
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		fontWeight: 400,
		'& > span': {
			padding: 0
		},
	},
}));